import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const realTimeSafetyListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fwhyyoulllovewild%2Fsafetysytsem.png?alt=media&token=ddf99112-4a4f-4648-99b9-c98c0d94d385",
  title: "Real Time Safety System",
  subtitle: "Your Whole Team Connected to the Water",
  page: WildNavigationType.REALTIMESAFETYSYSTEM,
}